import styled from 'styled-components';

import { StyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface TableCellProps extends BaseStyledComponentProps {
	as: string;
}

const StyledTable = styled('table')`
	width: 100%;
	border-collapse: collapse;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};
`;

const TableCell = styled('td')`
	box-sizing: border-box;
	position: relative;
	width: 10%;
	height: ${(props: TableCellProps) => props.as === 'th' ? '30px' : '62px'};
	padding: 4px;

	&:first-child {
		width: 1%;
	}

	&:nth-child(2) {
		width: 50%;
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 9)};

		tbody tr:last-child & {
			border: 0;
		}
	}

	${({ as, theme: { primary: { backgroundColor, strongColor } } }: TableCellProps) => as === 'th' && `
		position: sticky;
		top: 0;
		z-index: 1;
		background-color: ${backgroundColor !== 'transparent' ? backgroundColor : StyleColor.White };
		font-weight: 400;
		font-size: 11px;
		line-height: 12px;
		color: ${strongColor};
		text-align: left;
	`}
`;

const TableCellInner = styled('div')`
	position: relative;
	height: 100%;
`;

const TableCellInnerContent = styled('div')`
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	transform: translateY(-50%);
`;

const Label = styled('div')`
	font-size: 17px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 95.2)};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const Email = styled('div')`
	font-size: 11px;
	line-height: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export {
	StyledTable,
	TableCell,
	TableCellInner,
	TableCellInnerContent,
	Label,
	Email,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/styles.ts